/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Covers_LabelInputs */

const en_guides_covers_label = /** @type {(inputs: Guides_Covers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Covers`)
};

const ko_guides_covers_label = /** @type {(inputs: Guides_Covers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다루는 내용`)
};

const ja_guides_covers_label = /** @type {(inputs: Guides_Covers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扱う内容`)
};

/**
* | output |
* | --- |
* | "Covers" |
*
* @param {Guides_Covers_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_covers_label = /** @type {((inputs?: Guides_Covers_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Covers_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_covers_label(inputs)
	if (locale === "ko") return ko_guides_covers_label(inputs)
	return ja_guides_covers_label(inputs)
});